module.exports = __webpack_public_path__ + "static/assets/9ff2f106c8b5d0f7e53714767c7ac869.png";